var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-wide-skyscraper",class:{ 'banner-leaderboard--fixed' : _vm.fixed }},[_c('div',{staticClass:"banner-wide-skyscraper__temp"})])}
var staticRenderFns = []

export { render, staticRenderFns }